<!-- 发布管理-编辑自定义文章 -->
<template>
  <el-card>
    <div
      style="
        font-size: 16px;
        font-weight: bolder;
        padding-bottom: 20px;
        padding-left: 10px;
      "
    >
      自定义文章
    </div>
    <el-form ref="itemform" :model="item" :rules="rules" label-width="85px">
      <el-form-item label="文章标题" prop="Title">
        <el-input
          v-model.trim="item.Title"
          placeholder="请输入文章标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="文章内容" prop="Content">
        <mavon-editor
          ref="md"
          v-model="item.Content"
          :toolbars="toolbars"
          :box-shadow="false"
          @imgAdd="imgAdd"
          @imgDel="imgDel"
        />
      </el-form-item>
      <el-form-item label="视频地址">
        <el-input
          :class="{
            'mar-btm':
              item.VideoAddress.length > 1 &&
              index !== item.VideoAddress.length - 1,
          }"
          v-for="(obj, index) in item.VideoAddress"
          v-model="item.VideoAddress[index]"
          :key="index"
          placeholder="请填写视频的网址"
        >
          <i
            v-if="index === item.VideoAddress.length - 1"
            slot="append"
            class="fa fa-plus-circle cur-pointer"
            style="
              font-size: 18px;
              position: relative;
              top: 1px;
              color: #86c042;
            "
            @click="item.VideoAddress.push('')"
          ></i>
          <i
            v-if="item.VideoAddress.length > 1"
            slot="append"
            class="fa fa-minus-circle mar-lft cur-pointer"
            style="
              font-size: 18px;
              position: relative;
              top: 1px;
              color: #ee4a47;
              padding-left: 10px;
            "
            @click="item.VideoAddress.splice(index, 1)"
          ></i>
          <i
            slot="append"
            class="fas fa-fw fa-eye cur-pointer"
            style="
              font-size: 18px;
              position: relative;
              top: 1px;
              padding-left: 10px;
            "
            @click="viewVidio(item.VideoAddress[index])"
          ></i>
        </el-input>
      </el-form-item>
      <el-form-item label="文件上传" prop="file">
        <el-upload
          ref="upload"
          :action="uploadUrl"
          :headers="uploadHeader"
          :file-list="fileList"
          :auto-upload="false"
          :on-success="handleSuccess"
          :on-error="handleError"
          :on-remove="handleRemove"
          :on-preview="handlePreview"
        >
          <el-button size="mini" type="primary">选择文件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div style="text-align: right">
      <el-button @click="onShow">
        <i class="fas fa-fw fa-eye" aria-hidden="true" /> 预 览
      </el-button>
      <el-button :disabled="submitting" type="primary" @click="onSubmit">
        <i class="far fa-fw fa-save" aria-hidden="true" /> 确 定
      </el-button>
    </div>

    <el-dialog
    :visible="seeingVisible"
    :close-on-click-modal="false"
    width="75%"
    top="5vh"
    @close="seeingVisible=false"
  >
    <item-publish-detail
      :catalogueID="item.PublishCatalogueID"
      :group="value.BusinessGroup"
      :visible.sync="seeingVisible"
    />
    <div slot="footer">
      <el-button @click="seeingVisible=false">
        <i class="fas fa-fw fa-times" aria-hidden="true" />关 闭
      </el-button>
    </div>
  </el-dialog>
  </el-card>
</template>

<script>
import ItemPublishDetail from "./view-publish-detail.vue";
export default {
  components: {
    ItemPublishDetail,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
      uploadUrl: "",
      fileList: [],
      removeList: [],
      item: {},
      rules: {
        Title: [
          {
            required: true,
            message: "文章标题不能为空",
            trigger: "change, blur",
          },
          {
            max: 200,
            message: "文章标题不能超过200个字符",
            trigger: "change, blur",
          },
        ],
        Content: [
          {
            required: true,
            message: "文章内容不能为空",
            trigger: "change, blur",
          },
          {
            max: 64000,
            message: "文章内容不能超过64000个字符",
            trigger: "change, blur",
          },
        ],
      },
      requestRegObj: {
        reg: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/, // eslint-disable-line
        msg: "URL格式不正确",
      },
      attnum: 0,
      atttimes: 0,
      submitting: false,
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        htmlcode: true, // 展示html源码
        // /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        // /* 1.4.2 */
        navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true, // 预览
      },
      seeingVisible: false,
    };
  },
  mounted() {
    this.onOpen();
  },
  methods: {
    onOpen() {
      this.$refs.itemform.resetFields();
      this.$refs.upload.clearFiles();
      this.fileList = [];
      this.removeList = [];
      this.item = {};

      this.$axios
        .get(
          this.value.BusinessGroup === 0
            ? `dci/publishmanage/wiki`
            : `ipc/publishmanage/wiki`,
          {
            params: {
              PublishCatalogueID: this.value.ID,
            },
          }
        )
        .then((response) => {
          this.item = response.data;

          if (this.item.Attachments) {
            this.item.Attachments.forEach((ele) => {
              const file = {};
              // file.id = ele.ID;
              file.name = ele.Name;
              file.url = ele.Url;
              this.fileList.push(file);
            });
          } else {
            this.item.Attachments = [];
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});

      this.uploadUrl =
        this.value.BusinessGroup === 0
          ? `api/dci/publishmanage/wiki/upload`
          : `api/ipc/publishmanage/wiki/upload`;
    },

    // 对网址的验证
    targetValidator() {
      const errorMsg = this.requestRegObj.msg;
      const array = [];
      this.item.VideoAddress.forEach((obj, index) => {
        if (obj !== "" && !this.requestRegObj.reg.test(obj)) {
          array.push(index);
        }
      });
      if (array.length > 0) {
        this.$message({
          type: "warning",
          message: `${`视频地址中第${array
            .map((num) => num + 1)
            .join(" ")}个${errorMsg}`}`,
        });
        return false;
      }
      return true;
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        // 验证视频地址
        if (!this.targetValidator()) {
          return;
        }
        this.submitting = true;

        this.attnum = 0; //有没有新上传附件
        this.$refs.upload.uploadFiles.forEach((item) => {
          if (item.status === "ready") {
            this.attnum += 1;
          }
        });
        if (this.attnum > 0) {
          this.atttimes = 0;
          this.$refs.upload.uploadFiles.map((item) => item.status === "ready");
          this.$refs.upload.submit();
        } else {
          this.lastSubmit();
        }
      });
    },
    onShow() {
      this.seeingVisible = true;
    },
    imgAdd(pos, file) {
      const formData = new FormData();
      // formData.append("hint", "attachment");
      formData.append("file", file);
      this.$axios
        .post(
          this.value.BusinessGroup === 0
            ? "dci/publishmanage/wiki/imgUpload"
            : "ipc/publishmanage/wiki/imgUpload",
          formData
        )
        .then((response) => {
          this.$refs.md.$img2Url(pos, response.data.Url);
        });
    },
    imgDel(pos) {
      this.item.Content = this.item.Content.replace(
        `![img.jpg](${pos[0]})`,
        ""
      );
    },
    handleSuccess(response) {
      this.item.Attachments.push(response);
      this.atttimes += 1; //第几次调用改方法（每个文件都会调用一次，最后一次再触发保存）

      if (this.atttimes === this.attnum) {
        this.lastSubmit();
      }
    },
    handleRemove(file) {
      if (file.status === "success") {
        this.removeList.push(file.url);
      }
    },
    handlePreview(file) {
      const a = document.createElement("a");
      a.setAttribute("download", file.name);
      a.setAttribute("href", file.url);
      a.click();
    },
    lastSubmit() {
      if (this.removeList.length !== 0) {
        this.removeList.forEach((ele) => {
          this.item.Attachments.splice(
            this.item.Attachments.findIndex((item) => item.Url === ele),
            1
          );
        });
        this.$axios.delete("wiki/dispose", { data: { file: this.removeList } });
      }
      this.$axios
        .request({
          url:
            this.value.BusinessGroup === 0
              ? `dci/publishmanage/wiki/${this.item.ID}`
              : `ipc/publishmanage/wiki/${this.item.ID}`,
          method: "put",
          data: this.item,
        })
        .then(() => {
          this.$message.success("保存成功");
          this.onOpen();
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },
    viewVidio(url) {
      if (!this.requestRegObj.reg.test(url)) {
        this.$message({
          type: "warning",
          message: `URL格式不正确`,
        });
        return;
      }

      window.open(url, "_blank");
    },
  },
};
</script>
